var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFocus13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 44,
    viewBox: "0 0 55 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.917 2H21.417L15.167 9.5H7.66699C6.34091 9.5 5.06914 10.0268 4.13146 10.9645C3.19378 11.9021 2.66699 13.1739 2.66699 14.5V37C2.66699 38.3261 3.19378 39.5979 4.13146 40.5355C5.06914 41.4732 6.34091 42 7.66699 42H47.667C48.9931 42 50.2648 41.4732 51.2025 40.5355C52.1402 39.5979 52.667 38.3261 52.667 37V14.5C52.667 13.1739 52.1402 11.9021 51.2025 10.9645C50.2648 10.0268 48.9931 9.5 47.667 9.5H40.167L33.917 2Z",
    stroke: "#4771FE",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.667 32C31.8091 32 35.167 28.6421 35.167 24.5C35.167 20.3579 31.8091 17 27.667 17C23.5249 17 20.167 20.3579 20.167 24.5C20.167 28.6421 23.5249 32 27.667 32Z",
    stroke: "#4771FE",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocus13);
export default __webpack_public_path__ + "static/media/focus1-3.6512a421e4269c7be6ab877eb5e0817f.svg";
export { ForwardRef as ReactComponent };